import { UserFullStats } from "../types/user";

export const userStatsEndpoints = {
    getUserStats: {
        query: (userId: number) => `/users/${userId}/user-stats`,
        providesTags: (_result: any, _error: any, userId: number) => [
            { type: "UserStats", id: userId },
        ],
    },
    updateUserStats: {
        query: ({ userId, data }: { userId: number; data: Partial<UserFullStats> }) => ({
            url: `/users/${userId}/user-stats`,
            method: "PUT",
            body: data,
        }),
        invalidatesTags: (_result: any, _error: any, { userId }: { userId: number }) => [
            { type: "UserStats", id: userId },
        ],
    },
};

export const userStatsTags = ["UserStats"];
